export const getInitialState = (): any => ({
  modelVisualisationsData: {},
  modelVisualisationsStatus: 0
})